export default __webpack_public_path__ + "static/media/1_0096.27a1f9cf.webp";